// Our list of log groups.
export const LOG_GROUPS = {
  GTM: 'gtm'
};

/**
 * Checks localStorage to see if we should log out messages to the console for the given log group name.
 * @param {string} logGroup The log group.
 * @returns {boolean} Whether or not debug is enabled for the given log group.
 */
export const debugIsEnabled = logGroup => {
  // Ensure that a valid log group has been supplied.
  if (!Object.values(LOG_GROUPS).includes(logGroup)) {
    console.error('You must log to a group within the allowed logGroupings.');
  } else {
    // Grab the debug value from local storage.
    const debug = localStorage.getItem('debug');

    // Don't debug anything if debug isn't set.
    if (!debug) return false;
    else if (debug === 'true')
      // Setting debug to true will log all messages regardless of their log group.
      return true;
    else {
      // Alternatively, debug can be a whitelist object allowing individual log groups
      // (the keys) to be turned on by setting their values to true.
      try {
        const debugObject = JSON.parse(debug);
        if (debugObject.hasOwnProperty(logGroup))
          return debugObject[logGroup] === 'true';
      } catch (e) {
        console.error(
          `Please use 'true' or a valid JSON object in your localStorage debug value.`
        );
      }
    }
  }

  // The default is to not show anything.
  return false;
};

/**
 * Logs to the console if debug is enabled for a given log group.
 * @param {string} logGroup The log group.
 * @param {...any} args The remaining arguments to pass to console.log().
 * @returns {void}
 */
export const log = (logGroup, ...args) =>
  // If debug is enabled, log to the console.
  exports.debugIsEnabled(logGroup) && console.log(...args);



// WEBPACK FOOTER //
// ./src/utils/log/index.js